import React from 'react';
import { Link } from 'react-router-dom';
import { GovCard, GovIcon } from '@gov-design-system-ce/react';
import {
	useConfiguration,
	useTranslationWithNamespace,
} from '@gov-nx/core/service';
import type { PageCode } from '@gov-nx/module/page';
import { Button, LayoutGap } from '@gov-nx/ui/web';

export interface DrozdInfoViewProps {
	code: PageCode;
}

export const DrozdInfoView = ({ code }: DrozdInfoViewProps) => {
	const { appStoreMobileAppLink, googlePlayMobileAppLink } = useConfiguration();
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const ts = getLocalizeCurried(code);

	return (
		<LayoutGap gap="xl">
			<GovCard
				direction="horizontal"
				icon={
					<GovIcon
						slot="icon"
						type="complex"
						name="mobile-phone"
					/>
				}>
				<LayoutGap gap="s">
					<h2 className="text-headline-s! text-(--text-primary-color)!">
						{ts('drozd-info.nadpis')}
					</h2>
					<p className="mt-0!">{ts('drozd-info.popis')}</p>
					<div className="flex flex-row flex-wrap gap-4 mt-(--spacing-s)! mb-(--spacing-s)!">
						{appStoreMobileAppLink ? (
							<Button
								asChild
								color="primary"
								type="solid"
								size="m"
								isExpandedMobile
								aria-label={ts('drozd-info.tlacitko.wcag.app-store')}>
								<Link
									target="_blank"
									to={appStoreMobileAppLink}>
									{ts('drozd-info.tlacitko.app-store')}
								</Link>
							</Button>
						) : null}
						{googlePlayMobileAppLink ? (
							<Button
								asChild
								color="primary"
								type="solid"
								size="m"
								isExpandedMobile
								aria-label={ts('drozd-info.tlacitko.wcag.google-play')}>
								<Link
									target="_blank"
									to={googlePlayMobileAppLink}>
									{ts('drozd-info.tlacitko.google-play')}
								</Link>
							</Button>
						) : null}
					</div>
				</LayoutGap>
			</GovCard>
		</LayoutGap>
	);
};
